<template>
    <div>
        <table class="table table-sm table-hover table-bordered table-striped">
            <thead class="thead-orange">
                <tr>
                    <th>Nombre</th>
                    <th>Asignado</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="theTool in tools">
                    <td>{{ theTool.name}}</td>
                    <td><input type="checkbox" name="" id="" :value="theTool.id" v-model="selectedTools" /></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import clientsRepository from '../../../repositories/clients.repository';
    import { mapGetters } from 'vuex';

    export default {

        props: {
            myClient: {
                default: null
            },
            onAssigning: {
                type: Function
            }
        },

        data() {
            return {
                selectedTools: []
            };
        },
        watch: {
            myClient(client) {
                this.initializeTools();
            }
        },
        computed: {
            ...mapGetters(['tools'])
        },
        methods: {
            assignTools() {
                const payload = {
                    clientId: this.myClient.id,
                    selectedTools: this.selectedTools
                };
                const cr = Object.assign({}, clientsRepository);
                cr
                    .assignationToolToClient(payload)
                    .then(data => {
                        toastr.success(data.msg);
                        this.myClient.tools = [];
                        const theTools = this.tools.filter(item => this.selectedTools.includes(item.id));
                        this.myClient.tools = theTools;
                        typeof this.onAssigning === 'function' && this.onAssigning();
                    })
                    .catch(error =>
                        toastr.error("Ocurrio un error al realizar la asignación de herramientas")
                    );

            },
            initializeTools() {
                this.selectedTools = [];
                
                !!this.myClient.tools 
                    && this.myClient.tools.map(tool => this.selectedTools.push(tool.id));
            }

        },
        created() {
            this.load('tools');
        },
        mounted() {
            this.$bus.$on('assignTools.save', this.assignTools);
        },
        beforeDestroy() {
            this.$bus.$off('assignTools.save');
        }

    }
</script>